// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2UvAu","file":"styles_file__1rZTO"};